import { Injectable, isDevMode } from '@angular/core';
import { ContextsContextsDaoService } from 'src/app/dao/contexts-dao-services/contexts-contexts-dao-services/contexts-contexts-dao.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { EMPTY, Subject } from 'rxjs';
import { Context } from 'src/app/models/contexts-models/context.model';
import { map } from 'rxjs/internal/operators/map';
import { tap } from 'rxjs/internal/operators/tap';
import { UserStorageService } from '../../user-storage-service/user-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ContextsContextsService {

  accessToken = 'SES';
  refreshContextsListener = new Subject<any>();
  refreshContextListener = new Subject<any>();
  searchContextsListener = new Subject<any>();
  filterContextsListener = new Subject<any>();
  toggleContextsDispositionListener = new Subject<any>();

  constructor(private contextsContextsDaoService: ContextsContextsDaoService,
              private userStorageService: UserStorageService,
              private userService: UserService) { }

  public getContexts() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.contextsContextsDaoService.getContexts(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const contexts = new Array<Context>();
          o['data']['sessionsList'].forEach(
            (c) => {
              const sesionContext = new Context();
              Object.assign(sesionContext, c);
              contexts.push(sesionContext);
            }
          );
          return contexts;
        })
      );
    }
    return EMPTY;
  }

  public getContextsCounter() {
    if (this.userService.accessGranted(this.accessToken)) {
     return this.contextsContextsDaoService.getContextsCounter(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          return {
            availableContexts: o['data']['counters']['nbAvailables'],
            unavailableContexts: o['data']['counters']['nbDisabled']
          };
        })
      );
    }
    return EMPTY;
  }

  public getContextInfo(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.contextsContextsDaoService.getContextInfo(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const sesionContext = new Context();
          Object.assign(sesionContext, o['data']['sessionDetails']);
          return sesionContext;
        })
      );
    }
    return EMPTY;
  }

  public addNewContext(active, name, selectedCenter, token) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.contextsContextsDaoService.addNewContext(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), active, name, selectedCenter, token).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateContextInfo(internalId, active, name, selectedCenter, token) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.contextsContextsDaoService.updateContextInfo(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, active, name, selectedCenter, token).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public deleteContext(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.contextsContextsDaoService.deleteContext(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateContextStatus(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.contextsContextsDaoService.updateContextStatus(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public refreshContexts() {
    this.refreshContextsListener.next();
  }

  public refreshContextsListen() {
    return this.refreshContextsListener.asObservable();
  }

  public refreshContext() {
    this.refreshContextListener.next();
  }

  public refreshContextListen() {
    return this.refreshContextListener.asObservable();
  }

  public filterContexts(opts) {
    this.filterContextsListener.next(opts);
  }

  public filterContextsListen() {
    return this.filterContextsListener.asObservable();
  }

  public searchContexts(filterKey) {
    this.searchContextsListener.next(filterKey);
  }

  public searchContextsListen() {
    return this.searchContextsListener.asObservable();
  }

  public toggleContextsDisposition(viewDis) {
    this.toggleContextsDispositionListener.next(viewDis);
  }
  public toggleContextsDispositionListen() {
    return this.toggleContextsDispositionListener.asObservable();
  }
}
